import React from 'react';
import PropTypes from 'prop-types';
import { Svg, Path } from 'react-native-svg';

const B2B = ({ className, color }) => (
    <Svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.96 22.1302H5.07C3.93 22.1302 3 21.2002 3 20.0502V9.0202C3 7.8702 3.93 6.9502 5.07 6.9502H18.96C20.11 6.9502 21.03 7.8802 21.03 9.0202V20.0502C21.04 21.2002 20.11 22.1302 18.96 22.1302Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <Path
            d="M8.01956 7.63V5.03C8.01956 5.03 7.79956 3 11.9896 3C16.1796 3 15.9896 5.02 15.9896 5.02V7.64"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <Path d="M3 12.8999H21.04" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        <Path
            d="M7.43992 15.1604C7.15606 15.1604 6.91992 14.9242 6.91992 14.6404V13.9204C6.91992 13.6365 7.15606 13.4004 7.43992 13.4004C7.72378 13.4004 7.95992 13.6365 7.95992 13.9204V14.6404C7.95992 14.9311 7.72698 15.1604 7.43992 15.1604Z"
            fill={color}
            stroke={color}
        />
        <Path
            d="M16.5591 15.1604C16.2752 15.1604 16.0391 14.9242 16.0391 14.6404V13.9204C16.0391 13.6365 16.2752 13.4004 16.5591 13.4004C16.8429 13.4004 17.0791 13.6365 17.0791 13.9204V14.6404C17.0791 14.9311 16.8461 15.1604 16.5591 15.1604Z"
            fill={color}
            stroke={color}
        />
    </Svg>
);

B2B.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
};

B2B.defaultProps = {
    className: '',
    color: '#091849',
};

export default B2B;
